import * as CONST from '../ActionTypes';

const initialState = {
  subscriptionList: [],
  subscription: {},
  errorMessage: '',
  query: {
    currentPage: 0,
    itemsPerPage: 10,
    sort: 'id',
    isAsc: false,
    search: '',
  },
};

function subscription(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // 継続課金詳細取得
    // -----------------
    case CONST.GET_SUBSCRIPTION_DETAIL_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          subscription: action.payload,
        },
      );
    case CONST.GET_SUBSCRIPTION_DETAIL_FAILURE:
      return Object.assign(
        {},
        state,
        {
          subscription: {},
        },
      );
    // -----------------
    // 継続課金一覧取得
    // -----------------
    case CONST.GET_SUBSCRIPTION_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          subscriptionList: action.payload,
        },
      );
    case CONST.GET_SUBSCRIPTION_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          subscriptionList: [],
        },
      );
    // -----------------
    // queryパラメータの設定
    // -----------------
    case CONST.SET_SUBSCRIPTION_QUERY:
      return Object.assign(
        {},
        state,
        {
          query: Object.assign(
            {},
            state,
            action.payload,
          ),
        },
      );

    default:
      return state;
  }
}

export default subscription;
